module.exports = __webpack_public_path__ + "assets/img/how-to-donate-img-2.572cef90.jpg";